
import React from "react"
import "./index.less"
import warningIcon from "../../images/warning.svg"

const DashboardAlert = ({ children, type = "warning" }) => {

    if(!["warning", "important", "success"].includes(type)) {
        type = "warning"
    }

    return (
        <div className={`alert-details ${type}`}>
            <img className="alert-details__icon" src={warningIcon}/>
            <span>{children}</span>
        </div>
    )
}

export default DashboardAlert